<template>
  <div class="widget-access-page">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'widget-access-key-page',
}
</script>

<style scoped>

</style>
